/* Copyright 2021, Milkdown by Mirone. */
import { createNodeInParserFail, stackOverFlow } from '@milkdown/exception';
import { Mark } from 'prosemirror-model';
import { getStackUtil, maybeMerge } from '../utility';
import { createElement } from './stack-element';
const { size, push, top, open, close } = getStackUtil();
const openNode = (ctx) => (nodeType, attrs) => open(ctx)(createElement(nodeType, [], attrs));
const addNode = (ctx) => (nodeType, attrs, content) => {
    const node = nodeType.createAndFill(attrs, content, ctx.marks);
    if (!node)
        throw createNodeInParserFail(nodeType, attrs, content);
    push(ctx)(node);
    return node;
};
const closeNode = (ctx) => () => {
    ctx.marks = Mark.none;
    const element = close(ctx);
    return addNode(ctx)(element.type, element.attrs, element.content);
};
const openMark = (ctx) => (markType, attrs) => {
    const mark = markType.create(attrs);
    ctx.marks = mark.addToSet(ctx.marks);
};
const closeMark = (ctx) => (markType) => {
    ctx.marks = markType.removeFromSet(ctx.marks);
};
const addText = (ctx) => (createTextNode) => {
    const topElement = top(ctx);
    if (!topElement)
        throw stackOverFlow();
    const prevNode = topElement.pop();
    const currNode = createTextNode(ctx.marks);
    if (!prevNode) {
        topElement.push(currNode);
        return;
    }
    const merged = maybeMerge(prevNode, currNode);
    if (merged) {
        topElement.push(merged);
        return;
    }
    topElement.push(prevNode, currNode);
};
const build = (ctx) => () => {
    let doc = null;
    do {
        doc = closeNode(ctx)();
    } while (size(ctx));
    return doc;
};
export const createStack = () => {
    const ctx = {
        marks: [],
        elements: [],
    };
    return {
        build: build(ctx),
        openMark: openMark(ctx),
        closeMark: closeMark(ctx),
        addText: addText(ctx),
        openNode: openNode(ctx),
        addNode: addNode(ctx),
        closeNode: closeNode(ctx),
    };
};
//# sourceMappingURL=stack.js.map